import React, {useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Card, ListGroup, ListGroupItem} from 'react-bootstrap'
import './daily.css'
import {
    Link
} from "react-router-dom";

function getUrlParams(name:string) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); //定义正则表达式
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}


function List() {
    const [url,setUrl] = useState('')
    const [reports, setReports] = useState([]);
    const [header,setHeader] = useState({})

     useEffect(() => {
        const token = getUrlParams("token")
        const url_param = getUrlParams("url")


        setHeader({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        })

         if (url_param && null != url_param) {
             setUrl(url_param)
         }else{
             setUrl('https://crisisresponse.tihal.cn/')
         } 

    }, [])

    useEffect(() => {
        if (url !== '') {
        fetch(url+"tihal/epidemic-daily/list-v2",{method:'POST',headers: header})
            .then(res => res.json())
            .then(
                (result) => {
                    setReports(result.resp)
                },
                (error) => {
                    console.log(error)
                }
            )

        }
    }, [url])


    return (
        <div className="App">
            <div className="daily-list">
                {reports.map((item:any,index) => (
                    <Link to={{
                        pathname:'list-item',
                        state:{item:item},
                    }
                    }  key={index}>  <Card className="list-card">
                        <Card.Header>{ item.created_at }</Card.Header>
                        <ListGroup className="list-group-flush">
                            <ListGroupItem>{item.org.org_name}</ListGroupItem>
                            <ListGroupItem>{item.company.org_name}</ListGroupItem>
                        </ListGroup>
                    </Card>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default List;
